import { useEffect } from 'react';
import { usePlayerStore } from '@/store/playerStore';

export function ReactionOverlay() {
  const { reactions, removeReaction } = usePlayerStore();

  useEffect(() => {
    if (reactions.length === 0) return;
    const now = Date.now();
    const timers = reactions.map((r) => {
      const remaining = Math.max(0, 2500 - (now - r.createdAt));
      return setTimeout(() => {
        removeReaction(r.id);
      }, remaining);
    });

    return () => {
      timers.forEach(clearTimeout);
    };
  }, [reactions, removeReaction]);

  if (reactions.length === 0) return null;

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-25">
      {reactions.map((r) => (
        <div
          key={r.id}
          className="absolute bottom-20 flex flex-col items-center animate-reaction-float select-none"
          style={{
            left: `${Math.max(10, Math.min(85, r.xOffset))}%`,
          }}
        >
          <span className="text-3xl sm:text-4xl filter drop-shadow-md">{r.emoji}</span>
          <span className="text-[10px] font-medium text-white/80 bg-black/50 px-1.5 py-0.5 rounded backdrop-blur-xs mt-1">
            {r.senderName}
          </span>
        </div>
      ))}
    </div>
  );
}

